import type { Logger, SafeShell } from '../../../core';
import type { AppLifecycleHost, PageViewCollector } from './types';

/** 安装失败同样撤销已注册监听，卸载一个回调失败不能阻止另一个清理。 */
export function subscribeAppVisibility(host: AppLifecycleHost | undefined, collector: PageViewCollector, safe: SafeShell, logger?: Logger): () => void {
  const show = () => collector.signal({ type: 'app-show' });
  const hide = () => collector.signal({ type: 'app-hide' });
  let removeShow: (() => void) | undefined;
  let removeHide: (() => void) | undefined;
  const dispose = () => {
    safe.run(() => removeShow?.(), undefined, 'PageView.offAppShow');
    safe.run(() => removeHide?.(), undefined, 'PageView.offAppHide');
    removeShow = removeHide = undefined;
  };
  const installed = safe.run(() => {
    if (!host?.onAppShow || !host.offAppShow || !host.onAppHide || !host.offAppHide) return false;
    removeShow = () => host.offAppShow!(show);
    removeHide = () => host.offAppHide!(hide);
    host.onAppShow(show);
    host.onAppHide(hide);
    return true;
  }, false, 'PageView.appVisibility');
  if (!installed) {
    dispose();
    safe.run(() => logger?.warn('[AutoPageView] 宿主前后台订阅不可用，恢复行为将按普通页面显示采集'), undefined);
  }
  return dispose;
}
